import { ToastContent, ToastOptions, toast } from "react-toastify";
import { useLanguage } from "./useLanguage";


const useNotify = () => {
    const { direction } = useLanguage();

    const defaultOptions: ToastOptions<{}> = {
        position: direction === 'ltr' ? 'bottom-right' : 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        closeButton: false,
        className: "custom-toast-container mt-5"
    }

    const notifyError = (content: ToastContent, options?: ToastOptions) => {
        return toast.error(content, { ...defaultOptions, ...options })
    }

    const notifySuccess = (content: ToastContent, options?: ToastOptions) => {
        return toast.success(content, { ...defaultOptions, ...options })
    }

    const notifyInfo = (content: ToastContent, options?: ToastOptions) => {
        return toast.info(content, { ...defaultOptions, ...options })
    }

    return { notifyError, notifySuccess, notifyInfo }
}

export default useNotify
